import {useEffect, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";

export const AdminsTuitionPaymentPrintOptionsModal = (props: {
    active: boolean,
    closeHandler: any,
    from: string,
    to: string,
    classId: number
}) => {
    const [separatePages, setSeparatePages] = useState(false);
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const printIt = () => {
        const from = props.from;
        const to = props.to;
        const classId = props.classId;
        const sep = separatePages ? '1' : '0';
        props.closeHandler();
        window.open(`/print/admins/finance/tuition/${from}/${to}/${classId}/${sep}`);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>پرینت پرداخت‌های شهریه</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>گزینه‌های پرینت:</label>
                        <button className={"techaran-checkbox" + (separatePages ? ' active' : '')}
                                onClick={() => setSeparatePages(v => !v)}>
                            <i><CheckIcon/></i>
                            <span>هر روز در یک صفحه<em>فهرست پرداخت‌ها به تفکیک روز در صفحات مختلف پرینت می‌گیرد.</em></span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center" style={{marginTop:20,gap:5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={printIt}>
                                <b>پرینت</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};